// Morning Briefing — one model's photo, big. Opens from a row's picture; a click anywhere, Esc, Enter or Space closes ONLY this
// (MorningBriefing's key handler gives the big photo the keys first). A library photo is read at 1600 px (the Files
// thumbnail loader, once, cached); a Sales or dev-card picture is shown as it is, at the larger size.
import React, { useEffect, useRef } from 'react';
import ModelPhotoImg from '../ModelPhotoImg';
import { IcX } from './briefingIcons';
import styles from './briefingZoom.module.css';

const BIG = { w: 1600, h: 1200 };          // module constant: the loader's effect depends on the object

export default function BriefingZoom({ item, photo, onClose }) {
  const model = item.model || item.noun;
  const figRef = useRef(null);
  useEffect(() => { if (figRef.current) figRef.current.focus(); }, []);   // focus moves into the dialog; MorningBriefing puts it back on close
  return (
    <div className={styles.zoom} role="dialog" aria-modal="true" aria-label={`Photo of ${model}`} data-test="briefing-zoom-view" onClick={onClose}>
      <figure className={styles.fig} ref={figRef} tabIndex={-1}>
        <button type="button" className={styles.x} onClick={(e) => { e.stopPropagation(); onClose(); }} aria-label="Close the photo" data-test="briefing-zoom-close"><IcX /></button>
        <div className={styles.stage}>
          <ModelPhotoImg photo={photo} size={BIG} alt={`${model} photo`} className={styles.img} fallback={<span className={styles.none}>The photo could not be loaded</span>} />
        </div>
        <figcaption className={styles.cap}>
          <b>{model}</b>
          {item.pi ? <span><i>PI</i>{item.pi}</span> : null}
          {item.supplier ? <span className={styles.sup}>{item.supplier}</span> : null}
          <em>Click or Esc to close</em>
        </figcaption>
      </figure>
    </div>
  );
}
